export function parseInteger(value: string | number | undefined): number | undefined {
  if (value === null || value === undefined || value === '') return undefined

  return parseInt(String(value).replace('.', ''))
}

export function parseIntegerWithoutZero(value: string | number | undefined): number | undefined {
  if (value === 0 || value === '0' || value === undefined) return undefined

  return parseInteger(value)
}
